import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"

export const MenuFooterContactsConfig: Record<TemplateList, StaticMenuItem[]> = {
  [TemplateList.POGGERS]: [
    {
      name: 'Kontakty',
      url: 'https://www.cncenter.cz/kontakt',
      target: "_blank"
    },
    {
      name: 'Redakce',
      url: '/redakce',
    },
    {
      name: 'Inzerce',
      url: 'https://www.cncenter.cz/inzerce',
      target: "_blank",
    },
    // {
    //   name: 'Předplatné',
    //   url: 'https://www.ikiosek.cz/poggers',
    //   target: "_blank",
    // },
    {
      name: 'Kariéra',
      url: 'https://www.cncenter.cz/kariera',
      target: "_blank",
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      name: 'Kontakty',
      url: 'https://www.cncenter.cz/kontakt',
      target: "_blank"
    },
    {
      name: 'Redakce',
      url: '/redakce',
    },
    {
      name: 'Inzerce',
      url: 'https://www.cncenter.cz/inzerce',
      target: "_blank",
    },
    {
      name: 'Předplatné',
      url: 'https://www.ikiosek.cz/materidouska',
      target: "_blank",
    },
    {
      name: 'Kariéra',
      url: 'https://www.cncenter.cz/kariera',
      target: "_blank",
    },
  ],
  [TemplateList.HEYFOMO]: [
    {
      name: 'Kontakty',
      url: 'https://www.cncenter.cz/kontakt',
      target: "_blank"
    },
    {
      name: 'Redakce',
      url: 'https://heyfomo.cz/autori', // absolute — footer is embedded into foreign domain in Seznam News Feed render
    },
    {
      name: 'Inzerce',
      url: 'https://www.cncenter.cz/inzerce',
      target: "_blank",
    },
    {
      name: 'Kariéra',
      url: 'https://www.cncenter.cz/kariera',
      target: "_blank",
    },
  ]
}